import {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import moment from 'moment'
import 'moment/locale/tr'
import {ID, IHomeworkReport, IStudent} from '../../constants'
import {actionGetTotalSummaryReport} from '../../redux/education'

export function useClassReport(classroomId: ID, students: IStudent[], month: string) {
  const dispatch = useDispatch()
  const users = JSON.stringify(students.map(student => student.id))
  const [reports, setReports] = useState<IHomeworkReport[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [retry, setRetry] = useState(0)
  useEffect(() => {
    let active = true
    setReports([]); setError(false)
    if (!classroomId || users === '[]') {setLoading(false); return}
    setLoading(true)
    dispatch(actionGetTotalSummaryReport({classroomId, users,
      startDate: moment(month, 'YYYY-MM').startOf('month').toISOString(),
      endDate: moment(month, 'YYYY-MM').endOf('month').toISOString(),
    }, result => {
      if (!active) return
      const response = result.payload?.payload
      const data = response?.data
      const empty = data?.status === false && data?.errorName === 'NotFound'
      const success = result.type === 'SUCCESS' && (Array.isArray(data) || empty)
      setReports(success && Array.isArray(data) ? data : [])
      setError(!success); setLoading(false)
    }))
    return () => {active = false}
  }, [classroomId, users, month, retry, dispatch])
  return {reports, loading, error, reload: () => setRetry(value => value + 1)}
}
